import * as Sentry from '@sentry/react';
import { MacroAnalysisMessageType } from '@playcastdotio/Messaging';
import type { IPlayjectorService } from '../../services/playjector/interfaces/IPlayjectorService';
import type { IRealtimeService } from '../../services/realtime/IRealtimeService';
import type { IMessageRouter } from '../../services/MessageRouter';
import { MacroAnalysisCoordinator } from './MacroAnalysisCoordinator';
const instances = new WeakMap<IPlayjectorService, MacroAnalysisCoordinator>();

export function initializeMacroAnalysis(playjector: IPlayjectorService, realtime: IRealtimeService,
  router: IMessageRouter): MacroAnalysisCoordinator | undefined {
  if (!playjector.macroAnalysis) return undefined;
  const existing = instances.get(playjector);
  if (existing) return existing;
  const coordinator = new MacroAnalysisCoordinator(playjector.macroAnalysis, realtime, {
    now: () => performance.now(), every: (milliseconds, callback) => { const timer = setInterval(callback, milliseconds); return () => clearInterval(timer); },
  }, { event: (name, fields) => { if (Sentry.isInitialized()) Sentry.logger[name.includes('failed') ? 'error' : 'info'](name, fields); } });
  for (const type of Object.values(MacroAnalysisMessageType)) router.register(type, message => { void coordinator.handle(message); });
  coordinator.start();
  instances.set(playjector, coordinator);
  return coordinator;
}
